import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadPagePanel } from '../../../../components';
import { useGetMaterialOrder } from '../../../../features/cfi/material-order/api/get-material-order';
import { MaterialOrderContext, RefetchScope } from '../../../../features/cfi/material-order/context/MaterialOrderContext';
import { MaterialOrderContextType } from '../../../../features/cfi/material-order/types/MaterialOrderContextType';
import { RetailOrderContext } from '../../retail-order/context/RetailOrderContext';

export default function MaterialOrderPage(props: React.PropsWithChildren<unknown>) {

	const { order: retailOrder } = useContext(RetailOrderContext);

	const params = useParams();
	const materialOrderID = params.materialOrderID ? parseInt(params.materialOrderID) :
		retailOrder.details.materialOrders[0].materialOrderID;

	const [orderState, setOrderState] = useState<MaterialOrderContextType>({} as MaterialOrderContextType);
	const { data: moData, isLoading, refetch, isRefetching } = useGetMaterialOrder(materialOrderID);
	const [refetchScope, setRefetchScope] = useState<RefetchScope | undefined>();

	// Clear context on order ID change 
	if (orderState.details && orderState.details.materialOrderID !== materialOrderID) {
		setOrderState({} as MaterialOrderContextType);
	}

	useEffect(() => {
		if (moData) {
			switch (refetchScope) {
				case RefetchScope.Files:
					setOrderState({ details: { ...orderState.details, files: moData.files } });
					break;

				case RefetchScope.Notes:
					setOrderState({ details: { ...orderState.details, notes: moData.notes } });
					break;

				default:
					setOrderState({ details: moData });
					break;
			}
		}
	}, [moData]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<MaterialOrderContext.Provider value={{
					order: orderState,
					modifyOrder: (details) => setOrderState(
						{ ...orderState, details: details }),
					refetchOrder: (scope?: RefetchScope) => {
						setRefetchScope(scope);
						return refetch();
					}
				}}>

					{props.children}

				</MaterialOrderContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isRefetching} />
		</React.Fragment>)
}
